(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(pointer: fine)").matches;

  var reveals = document.querySelectorAll(".cy-reveal");
  if (!reduce && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add("is-in");
    });
  }

  var media = document.querySelector("[data-cy-parallax]");
  if (media && !reduce) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 900) * 0.08;
        media.style.transform = "translate3d(0," + y.toFixed(2) + "px,0)";
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  if (fine && !reduce) {
    document.querySelectorAll("[data-magnetic]").forEach(function (btn) {
      btn.addEventListener("mousemove", function (event) {
        var rect = btn.getBoundingClientRect();
        var x = (event.clientX - (rect.left + rect.width / 2)) * 0.16;
        var y = (event.clientY - (rect.top + rect.height / 2)) * 0.22;
        btn.style.transform = "translate3d(" + x.toFixed(1) + "px," + y.toFixed(1) + "px,0)";
      });
      btn.addEventListener("mouseleave", function () {
        btn.style.transform = "";
      });
    });

    document.querySelectorAll(".cy-frame img, .cy-cutout, .cy-edition__media img, .cy-nfc img, .cy-nfc .cy-shot").forEach(function (el) {
      var stage = el.closest(".cy-frame, .cy-nfc, .cy-edition__media, .cy-metal__visual") || el.parentElement;
      if (!stage) return;
      stage.addEventListener("mousemove", function (event) {
        var rect = stage.getBoundingClientRect();
        var px = (event.clientX - rect.left) / rect.width - 0.5;
        var py = (event.clientY - rect.top) / rect.height - 0.5;
        el.style.transform =
          "perspective(900px) rotateY(" + (px * 12).toFixed(2) + "deg) rotateX(" + (-py * 10).toFixed(2) + "deg) translateZ(12px)";
      });
      stage.addEventListener("mouseleave", function () {
        el.style.transform = "";
      });
    });
  }
})();
